<template>
  <div class="lamp-content">
    <!-- <h3 class="sub_title">策略的分配情况：</h3> -->
    <el-transfer
      filterable
      :data="allDevices"
      :titles="['未分配的设备', '已分配的设备']"
      :button-texts="['从列表删除', '添加到列表']"
      v-model="allocated"
      @change="dataChange"
    >
    </el-transfer>
    <br />
    <el-button type="primary" @click="cancel">返回</el-button>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList"
import strategyApi from "@/api/light/strategy"
export default {
  name: "sendStrategy",
  props: {
    sendData: {
      type: Object
    },
  },
  data() {
    return {
      allDevices: [],
      allocated: []
    }
  },
  methods: {
    dataChange(value, direction, movedKeys) {
      
      if (direction === "right") { // 分配
        console.log('direction',direction)
        console.log('movedKeys',movedKeys)
        strategyApi.allotFen({
          type: 1,
          lamp_ids: movedKeys.toString(),
          stg_id: this.sendData.stg_id
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else { // 取消分配
        strategyApi.allotFen({
          type: 0,
          lamp_ids: movedKeys.toString(),
          stg_id: 0
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("取消分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    getAllDevices() { // 获取所有路灯，策略是单灯（单灯的所有路灯），策略是双灯（双灯的所有路灯）
      let is_double = this.sendData.is_double;
      let type = this.sendData.type;
      if(is_double==0){ // 0 传后台 识别不了
        is_double=2
      }
      lightListApi.lightList({
        type: type,
        is_double: is_double,
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const device of res.data.data.list) {
            this.allDevices.push({
              key: device.lamp_id,
              label: device.name
            })
          }

          this.getAllocated()
        }
      })
    },
    getAllocated() { // 获取该策略下的所有路灯
      lightListApi.lightList({
        stg_id: this.sendData.stg_id,
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const alodevice of res.data.data.list) {
            this.allocated.push(alodevice.lamp_id)
          }
        }
      })
    },
    cancel() {
      this.$emit('closeMethod')
    }
  },
  created() {
    this.getAllDevices()
  }
}
</script>
